import type { MenuPrivate } from '../entities/MenuPrivate'

export const MenuPrivateTravelerMessages = 'messages'
export const MenuPrivateTravelerBookings = 'bookings'
export const MenuPrivateTravelerOutings = 'outings'

const menu: MenuPrivate = [
  {
    id: MenuPrivateTravelerBookings,
    name: 'menu.private_menu.bookings',
    href: '/viajero/:id/menu/reservas',
    icon: 'i-heroicons-key',
    selected: false,
    unread: 0,
  },
  {
    id: MenuPrivateTravelerOutings,
    name: 'menu.private_menu.outings',
    href: '/traveler/:id/outings/list',
    icon: 'i-heroicons-globe-europe-africa',
    selected: false,
    unread: 0,
  },
  {
    id: MenuPrivateTravelerMessages,
    name: 'menu.private_menu.messages',
    href: '/traveler/:id/menu/messages',
    icon: 'i-heroicons-chat-bubble-left-ellipsis',
    selected: false,
    unread: 0,
  },
  {
    id: 'favourites',
    name: 'menu.private_menu.favourites',
    href: '/viajero/:id/listas',
    icon: 'i-heroicons-heart',
    selected: false,
    unread: 0,
  },
  {
    id: 'opinions',
    name: 'menu.private_menu.opinions',
    href: '/viajero/:id/menu/opiniones',
    icon: 'i-heroicons-star',
    selected: false,
    unread: 0,
  },
  {
    id: 'helpCenter',
    name: 'menu.private_menu.helpCenter',
    href: 'https://ayuda.escapadarural.com/support/home',
    icon: 'i-heroicons-question-mark-circle',
    selected: false,
    unread: 0,
    target: '_blank',
  },
]

export default menu
